import React, { useEffect } from "react";
import FooterPortugal2030Cores from "../data/logo/BarraAssinaturas_RGBCor.png";
import FooterPortugal2030Branco from "../data/logo/BarraAssinaturas_RGBBranco.png";
import { useMediaQuery } from "react-responsive";
import "../css/Footer.css";

const PORTUGAL2030_FILE_URL = `${process.env.PUBLIC_URL || ""}/files/Urbcircular_-_Ficha_de_Operacao41.pdf`;

function Footer(props) {
  const isMobileS = useMediaQuery({ query: "(max-width: 320px)" });
  const isMobileM = useMediaQuery({
    minWidth: 321,
    maxWidth: 375,
  });
  const isMobileL = useMediaQuery({
    minWidth: 376,
    maxWidth: 425,
  });
  const isTablet = useMediaQuery({
    minWidth: 426,
    maxWidth: 768,
  });
  const isLaptop = useMediaQuery({
    minWidth: 769,
    maxWidth: 1024,
  });

  useEffect(() => {
    if (
      isMobileS === true ||
      isMobileM === true ||
      isMobileL === true ||
      isTablet === true ||
      isLaptop === true
    ) {
      if (props.contacts === "true") {
        document.getElementById("footer").style.position = "sticky";
        document.getElementById("footer").style.bottom = 0;
        document.getElementById("footer").style.left = 0;
      }
    } else {
      if (props.contacts === "true") {
        document.getElementById("footer").style.position = "sticky";
        document.getElementById("footer").style.bottom = 0;
        document.getElementById("footer").style.left = 0;
      }
      else {
        document.getElementById("footer").style.position = "relative";
      }
      
    }
  }, [isMobileS, isMobileM, isMobileL, isTablet, isLaptop]);

  const handleOpenBehance = () => {
    const behanceUrl = "https://www.behance.net/providenciadesign";
    window.open(behanceUrl, "_blank");
  };

  const handleOpenLinkedIn = () => {
    const linkedInUrl =
      "https://www.linkedin.com/company/provid%C3%AAnciadesign/";
    window.open(linkedInUrl, "_blank");
  };

  const handleOpenVimeo = () => {
    const VimeoUrl = "https://www.vimeo.com/providenciadesign";
    window.open(VimeoUrl, "_blank");
  };

  const handleOpenInstagram = () => {
    const InstagramUrl = "https://www.instagram.com/providenciadesign/";
    window.open(InstagramUrl, "_blank");
  };

  return (
    <div id="footer" style={{ position: "relative", zIndex: "100" }}>
      {props.bg === "white" ? (
        <>
          <div className="grid-container__footer">
            <div className="footer__logos__test">
              <div>
                <a href={PORTUGAL2030_FILE_URL} target="_blank" rel="noopener noreferrer">
                  <img alt="Logo" src={FooterPortugal2030Cores} />
                </a>
              </div>
            </div>
            <div className="footer__links__test">
              <div>
                <span>
                  © 1985 – 2026<br></br>ProvidênciaDesign
                </span>
              </div>
              <div onClick={handleOpenBehance}>
                <p>Behance</p>
              </div>
              <div onClick={handleOpenVimeo}>
                <p>Vimeo</p>
              </div>
              <div onClick={handleOpenLinkedIn}>
                <p>LinkedIn</p>
              </div>
              <div onClick={handleOpenInstagram}>
                <p>Instagram</p>
              </div>
            </div>
          </div>
          <div className="grid-container__footer__mobile__home">
            <div className="menu__mobile__left">
              <div style={{ alignSelf: "end" }}>
                <div className="menu__mobile__Mainfooter_links">
                  <p style={{ opacity: "60%", fontSize: "12px" }}>
                    © 1985 – 2026<br></br> ProvidênciaDesign
                  </p>
                </div>
                <div className="menu__mobile__Mainfooter__logos">
                  <a href={PORTUGAL2030_FILE_URL} target="_blank" rel="noopener noreferrer">
                    <img alt="Logo" src={FooterPortugal2030Cores} />
                  </a>
                </div>
              </div>
            </div>
            <div className="menu__mobile__right">
              <div>
                <div className="menu__mobile__Mainfooter_links">
                  <p style={{ cursor: "pointer" }} onClick={handleOpenBehance}>
                    Behance
                  </p>
                  <p style={{ cursor: "pointer" }} onClick={handleOpenVimeo}>
                    Vimeo
                  </p>
                  <p style={{ cursor: "pointer" }} onClick={handleOpenLinkedIn}>
                    LinkedIn
                  </p>
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={handleOpenInstagram}
                  >
                    Instagram
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="grid-container__footer">
            <div className="footer__logos__test">
              <div>
                <a href={PORTUGAL2030_FILE_URL} target="_blank" rel="noopener noreferrer">
                  <img alt="Logo" src={FooterPortugal2030Branco} />
                </a>
              </div>
            </div>
            <div className="footer__links__test" style={{ color: "white" }}>
              {props.contacts === "true" ? (
                <>
                  <div>
                    <span>
                      © 1985 – 2026<br></br>ProvidênciaDesign
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <span>
                      © 1985 – 2026<br></br>ProvidênciaDesign
                    </span>
                  </div>
                  <div onClick={handleOpenBehance}>
                    <p>Behance</p>
                  </div>
                  <div onClick={handleOpenVimeo}>
                    <p>Vimeo</p>
                  </div>
                  <div onClick={handleOpenLinkedIn}>
                    <p>LinkedIn</p>
                  </div>
                  <div onClick={handleOpenInstagram}>
                    <p>Instagram</p>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="grid-container__footer__mobile__home">
            <div className="menu__mobile__left">
              <div style={{ alignSelf: "end" }}>
                <div
                  className="menu__mobile__Mainfooter_links"
                  style={{ color: "white" }}
                >
                  <p>
                    © 1985 – 2026<br></br> ProvidênciaDesign
                  </p>
                </div>
                <div className="menu__mobile__Mainfooter__logos">
                  <a href={PORTUGAL2030_FILE_URL} target="_blank" rel="noopener noreferrer">
                    <img alt="Logo" src={FooterPortugal2030Branco} />
                  </a>
                </div>
              </div>
            </div>
            <div className="menu__mobile__right">
              <div>
                <div
                  className="menu__mobile__Mainfooter_links"
                  style={{ color: "white" }}
                >
                  {props.contacts === "true" ? (
                    <></>
                  ) : (
                    <>
                      <p
                        style={{ cursor: "pointer" }}
                        onClick={handleOpenBehance}
                      >
                        Behance
                      </p>
                      <p
                        style={{ cursor: "pointer" }}
                        onClick={handleOpenVimeo}
                      >
                        Vimeo
                      </p>
                      <p
                        style={{ cursor: "pointer" }}
                        onClick={handleOpenLinkedIn}
                      >
                        LinkedIn
                      </p>
                      <p
                        style={{ cursor: "pointer" }}
                        onClick={handleOpenInstagram}
                      >
                        Instagram
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Footer;
